/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlocked_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Record unlocked successfully" |
*
* @param {Explorer_Info_Unlocked_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlocked_success_toast = /** @type {((inputs?: Explorer_Info_Unlocked_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlocked_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement deverrouille avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz erfolgreich entsperrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record sbloccato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись успешно разблокирована.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro desbloqueado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("记录已成功解锁")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードのロック解除に成功しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड सफलतापूर्वक अनलॉक हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro desbloqueado com sucesso")
	return /** @type {LocalizedString} */ ("Record unlocked successfully")
});